import axios from 'axios';

export async function resolveIP(ip) {
  try {
    let urlEnd = `https://ipapi.co/${ip}/json/`;
	axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';  
    const [countryRes, geoRes] = await Promise.all([
      axios.get(`https://radioital.com/api/public/api/site/ips/${ip}`).then(r => r.json()),
	  axios.get(`https://radioital.com/api/public/api/site/geo/${ip}`).then(r => r.json())
    ]);

    if (!countryRes?.country) return null;
    if (!geoRes?.lat || !geoRes?.lon) return null;

    return {
      ip,
      country: countryRes.country,
      lat: geoRes.lat,
      lng: geoRes.lon
    };
  } catch {
    return null;
  }
}